import { type UseQueryResult, useQuery } from 'react-query';
import {
  CurrentTenantInfoService,
  // eslint-disable-next-line camelcase
  type Wealthlane_TenantInfoVo,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { ERROR_TYPE } from '../../constants/common';

const useGetCurrentTenantInfo = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  enabled: boolean = true
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_TenantInfoVo | undefined,
  unknown
> => {
  const currentTenantInfo = useQuery(
    ['getCurrentTenantInfo', enabled],
    async () => {
      return await handleRequest(CurrentTenantInfoService.getApiCustomerApiTenantCurrent());
    },
    {
      onError(err: any) {
        if (err?.message === ERROR_TYPE.NOT_FOUND) {
          window.dispatchEvent(new CustomEvent('TENANT_DELETED'));
        }
      },
      refetchOnWindowFocus: 'always',
      enabled,
    }
  );
  return currentTenantInfo;
};

export default useGetCurrentTenantInfo;
